module.exports = __webpack_public_path__ + "static/media/stonkAppStore.0fe6cf92.PNG";